import * as React from 'react';
export default function SvgBeautyTube() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.02 6.544A2.25 2.25 0 0 1 8.25 4h6.58a2.25 2.25 0 0 1 2.23 2.544l-1.105 8.393a2.247 2.247 0 0 1-.972 1.57c.195.334.307.722.307 1.136v.107A2.25 2.25 0 0 1 13.04 20h-3a2.25 2.25 0 0 1-2.25-2.25v-.107c0-.414.112-.802.307-1.135a2.248 2.248 0 0 1-.972-1.571L6.02 6.544ZM8.25 5.5a.75.75 0 0 0-.743.848l1.105 8.393a.75.75 0 0 0 .743.652h4.37a.75.75 0 0 0 .743-.652l1.105-8.393a.75.75 0 0 0-.744-.848H8.25Zm1.79 11.393a.75.75 0 0 0-.75.75v.107c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75v-.107a.75.75 0 0 0-.75-.75h-3Zm-.5-9.752a.75.75 0 1 0 0 1.5h4a.75.75 0 1 0 0-1.5h-4Z",
    fill: "currentColor"
  }));
}